import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { isValidZip } from '../utils/validation';
import { US_STATES } from '../utils/states';

export default function Step05_Address({ onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [errs, setErrs] = useState({});
  const addr = state.currentAddress;

  const set = (field, val) => {
    dispatch({ type: 'SET_NESTED', key: 'currentAddress', value: { [field]: val } });
    setErrs(e => ({ ...e, [field]: '' }));
  };

  const next = () => {
    const e = {};
    if (!addr.street.trim()) e.street = 'Street address required';
    if (!addr.city.trim()) e.city = 'City required';
    if (!addr.state) e.state = 'State required';
    if (!isValidZip(addr.zip)) e.zip = 'Valid ZIP code required (XXXXX or XXXXX-XXXX)';
    if (!addr.years && addr.years !== 0) e.years = 'Years required';
    else if (isNaN(parseFloat(addr.years)) || parseFloat(addr.years) < 0) e.years = 'Enter a valid number';
    if (Object.keys(e).length) { setErrs(e); return; }
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Current Address</h2>
      <div className="field-group">
        <label className="field-label">Street Address <span className="required">*</span></label>
        <input className={`field-input ${errs.street ? 'error' : ''}`} value={addr.street}
          onChange={e => set('street', e.target.value)} placeholder="123 Main St" />
        {errs.street && <div className="field-error">{errs.street}</div>}
      </div>
      <div className="field-row">
        <div className="field-group">
          <label className="field-label">City <span className="required">*</span></label>
          <input className={`field-input ${errs.city ? 'error' : ''}`} value={addr.city}
            onChange={e => set('city', e.target.value)} placeholder="City" />
          {errs.city && <div className="field-error">{errs.city}</div>}
        </div>
        <div className="field-group">
          <label className="field-label">State <span className="required">*</span></label>
          <select className={`field-select ${errs.state ? 'error' : ''}`} value={addr.state}
            onChange={e => set('state', e.target.value)}>
            <option value="">Select...</option>
            {US_STATES.map(s => <option key={s.code} value={s.code}>{s.code} — {s.name}</option>)}
          </select>
          {errs.state && <div className="field-error">{errs.state}</div>}
        </div>
      </div>
      <div className="field-row">
        <div className="field-group">
          <label className="field-label">ZIP Code <span className="required">*</span></label>
          <input className={`field-input ${errs.zip ? 'error' : ''}`} value={addr.zip}
            onChange={e => set('zip', e.target.value)} placeholder="XXXXX" inputMode="numeric" />
          {errs.zip && <div className="field-error">{errs.zip}</div>}
        </div>
        <div className="field-group">
          <label className="field-label">Years at This Address <span className="required">*</span></label>
          <input className={`field-input ${errs.years ? 'error' : ''}`} value={addr.years}
            onChange={e => set('years', e.target.value)} placeholder="e.g. 2.5" inputMode="decimal" type="number" min="0" step="0.5" />
          {errs.years && <div className="field-error">{errs.years}</div>}
        </div>
      </div>
      {parseFloat(addr.years) < 3 && addr.years !== '' && (
        <div className="info-box" style={{ marginBottom: 12 }}>
          You will be asked for your previous address on the next screen.
        </div>
      )}
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
